import { useBox } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { Box, Cylinder, ObjectProps, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useBox(() => ({
    mass: 30,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    args: [7, 9, 2],
    type: 'Static'
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind}>
      <Box position={[0, 0, 0]} args={[7, 9, 2]} />
      <Box position={[0, 0, 1]} args={[0.1, 8.8, 0.1]} color="#2a2a2a" />

      <Cylinder position={[0.5, 4, 1]} rotation={[Math.PI / 2, 0, 0]} args={[0.1, 0.1, 0.1, 8]} color="#2a2a2a" />
      <Cylinder position={[-0.5, 4, 1]} rotation={[Math.PI / 2, 0, 0]} args={[0.1, 0.1, 0.1, 8]} color="#2a2a2a" />
    </group>
  );
};
